// Variação do consumo do último mês contra a média cadastrada da UC.
//
// Saiu de `views/Gestao/Rateio/consumoHistorico.ts` para cá quando o vigia da
// Vick passou a disparar este alerta: aquele arquivo importa o cliente Supabase
// do navegador, que não existe no Deno. A conta é a mesma, e é uma só — o
// banner do Rateio e o aviso da IA não podem discordar sobre a mesma UC.
//
//   node --test supabase/functions/_shared/__tests__/variacaoConsumo.test.ts

/**
 * O quanto o consumo real pode variar da média cadastrada antes de acender o
 * alerta da Revisão Inteligente. Baixado de 20 para 15 em ago/2026 a pedido do
 * CEO (solicitação 4646).
 *
 * ⚠️ Coincide em valor com `MARGEM_ERRO_PADRAO_PERCENT` (consumoHistorico.ts)
 * mas é outro conceito. Mexer num não mexe no outro.
 */
export const LIMIAR_ALERTA_DELTA_PERCENT = 15;

export type DeltaConsumo = {
  consumoUltimoMesKwh: number;
  mesReferenciaUltimoMes: string;
  consumoMedioKwh: number;
  /** `null` quando não há base de comparação (média cadastrada <= 0). */
  deltaPercent: number | null;
  alerta: boolean;
};

/** O mínimo que este módulo precisa de uma fatura. */
export type FaturaComConsumo = {
  mes_referencia: string;
  consumo_ativo_kwh: number;
};

const round2 = (n: number) => Math.round(n * 100) / 100;

/**
 * `null` quando não há fatura recente para a UC — sem base de comparação não
 * existe variação, e devolver zero afirmaria "não variou", que é diferente.
 */
export function calcularDelta(
  historicoUc: readonly FaturaComConsumo[],
  consumoMedioKwh: number,
): DeltaConsumo | null {
  const ultima = historicoUc[0];
  if (!ultima || typeof ultima.consumo_ativo_kwh !== 'number') return null;

  const deltaPercent =
    consumoMedioKwh > 0
      ? round2(((ultima.consumo_ativo_kwh - consumoMedioKwh) / consumoMedioKwh) * 100)
      : null;

  return {
    consumoUltimoMesKwh: ultima.consumo_ativo_kwh,
    mesReferenciaUltimoMes: ultima.mes_referencia,
    consumoMedioKwh,
    deltaPercent,
    alerta: deltaPercent !== null && Math.abs(deltaPercent) >= LIMIAR_ALERTA_DELTA_PERCENT,
  };
}
